import { Grid, Typography } from "@mui/material";
import React from "react";

const ExListNumberBtn = ({ index, onClick, ex }) => {
  return (
    <Grid
      onClick={onClick}
      borderRadius={"99px"}
      border="1px solid black"
      width={"24px"}
      height={"24px"}
      container
      justifyContent="center"
      alignItems="center"
      bgcolor={ex?.answerScore >= 1 && "black"}
      color={ex?.answerScore >= 1 && "white"}
      mx="auto"
      sx={{
        cursor: "pointer",
        "&:hover": {
          boxShadow: "0px 0 0 0.2rem rgb(92 92 92/50%);",
          // background: "black",
          // color: "white",
        },
        "&:active": {
          transform: "scale(0.9)",
        },
      }}
    >
      <Typography fontSize="14px" fontWeight={500}>
        {index + 1}
      </Typography>
    </Grid>
  );
};

export default ExListNumberBtn;
